import { Component, OnInit, OnChanges } from '@angular/core';
import { RequestTools } from '@service/request.tools';
import { CheckTools } from '@service/check.tools';
import { ParamUrlService } from '@service/paramurl.service';
import { Router } from '@angular/router';
import { MenuServiceInt } from '@core/_services/menu.serviceint';
import { Tools } from '@service/tools';
import { LayoutService } from '../../layout/service/app.layout.service';
import { MessagesService } from '@core/_services/messages.service';
import { TranslateService } from '@ngx-translate/core';
import { lastValueFrom } from 'rxjs';

@Component({
    selector: 'dashbskold',
    templateUrl: 'dashbskold.component.html',
    styleUrls: ['dashbskold.component.scss'],
})
export class DashBskOldComponent implements OnInit, OnChanges {
    public fr: any;
    public error = false;
    public listColumns: any[];
    public resultDisplay: any;
    public nbRow = 100;
    public isDesktop: boolean = false;
    public rowGroupMetadata: any;

    constructor(
        protected _messageService: MessagesService,
        private checkTools: CheckTools,
        private requestTools: RequestTools,
        private tools: Tools,
        private router: Router,
        private paramUrlService: ParamUrlService,
        private menu: MenuServiceInt,
        private main: LayoutService,
        private translate: TranslateService
    ) {
        this.isDesktop = this.main.isDesktop();
        this.resultDisplay = new Array();
    }

    public ngOnInit() {
        this.listColumns = this.getlistColumns();    
        this.execStat();
    }

    public ngOnChanges() {}

    private async execStat() {
        let wRes;
        let wData;
        let wTranfert: any;
        wRes = false;
        try {
            wData = this.setRequest('bskold', 0);
            wRes = await lastValueFrom(this.requestTools.getBasketListOld(wData, '*'));
            this.checkTools.checkFork(wRes);
            if (this.checkTools.getRes() === false) {
                this._messageService.addErrorMsg(this.checkTools.getMsg());
                return;
            }    
            wTranfert = this.tools.getBasketTransfert(wRes.getBasketList, null, false, null, null, null);
            this.addBasket(wRes.getBasketOld.ItemList.Item,  wTranfert);
            this.updateRowGroupMetaData();
        } catch (error) {
            console.log('Error', error);
            this._messageService.addErrorMsg(this.translate.instant('Err_ListBsk'));
        }
    }

    private addBasket(aData, aTranfert) {
        let wInfo: any;
        aData.forEach((item) => {
            wInfo = this.getInfoBsk(item, aTranfert);
            if (wInfo !== null) {
                this.resultDisplay.push({
                    name: wInfo.name,
                    docname: wInfo.docname,
                    date: wInfo.date,
                    label: wInfo.label,
                    basketType: wInfo.basketType,
                    url: wInfo.url,
                    defUrl: wInfo.defUrl,
                    description: wInfo.description,
                    labelName: wInfo.name + wInfo.label,  
                    color: wInfo.color
                });
            }
        });
    }

    public updateUrl(aData) {
        aData.url = aData.defUrl;
    }

    private getInfoBsk(aItem, aTranfert) {
        let wInfo: any;
        let wRes: any;
        wInfo = null;
        if (aItem.basketType === '1_btMail') {
            wRes = this.findBasket(aTranfert.wBasketMailList, aItem.bsk_name);
        }
        if (aItem.basketType === '2_btCollect') {
            wRes = this.findBasket(aTranfert.wBasketCollectList, aItem.bsk_name);
        }
        if (aItem.basketType === '3_btAction') {
            wRes = this.findBasket(aTranfert.wBasketActionList, aItem.bsk_name);
        }
        if (aItem.basketType === '4_btInput') {
            wRes = this.findBasket(aTranfert.wBasketInputList, aItem.bsk_name);
        }
        if (aItem.basketType === '5_btOutput') {
            wRes = this.findBasket(aTranfert.wBasketOutputList, aItem.bsk_name);
        }
        if (aItem.basketType === '6_btPublish') {
            wRes = this.findBasket(aTranfert.wBasketPublishList, aItem.bsk_name);
        }        
        if (aItem.basketType === '7_btSystem') {
            wRes = this.findBasket(aTranfert.wBasketSystemList, aItem.bsk_name);
        }  
        if (wRes !== null) {
            wInfo = {
                name: aItem.bsk_name,
                docname: aItem.docname,
                date: aItem.bsk_docdate,
                label: wRes.Label,
                basketType: wRes.basketType,
                url: wRes.url,
                defUrl: wRes.defUrl,
                description: wRes.Description,
                color: wRes.color
            };
        }
        return wInfo;
    }

    private findBasket(aList, aName) {        
        let wIndex = -1;
        let wRes = null;
        wIndex = aList.findIndex((item) => {
            return item.Information.Name === aName;
        });
        if (wIndex !== -1) {
            wRes = aList[wIndex].Information;
        }
        return wRes;
    }

    private updateRowGroupMetaData() {
        this.rowGroupMetadata = {};
        if (this.resultDisplay) {
            for (let i = 0; i < this.resultDisplay.length; i++) {
                let rowData = this.resultDisplay[i];
                let label = rowData.labelName;
                if (i == 0) {
                    this.rowGroupMetadata[label] = { index: 0, size: 1 };
                }
                else {
                    let previousRowData = this.resultDisplay[i - 1];
                    let previousRowGroup = previousRowData.labelName;
                    if (label === previousRowGroup)
                        this.rowGroupMetadata[label].size++;
                    else
                        this.rowGroupMetadata[label] = { index: i, size: 1 };
                }
            }
        }
    }

    private setRequest(aStat, aCount) {
        let wRequest = {
            RequestName: aStat,
            RequestCount: aCount,
        };
        return wRequest;
    }


    public onRowSelect(event) {
        this.paramUrlService.basketName = event.data.name;
        this.router.navigate(['/page-basket-list']);
    }

    private getlistColumns() {
        let wItem: any;
        let wColList = new Array();
        wItem = { header: '', field: 'url', type: 'String' };
        wColList.push(wItem);
        wItem = { header: this.translate.instant('Col_Inti_1'), field: 'label', type: 'String' };
        wColList.push(wItem);
        wItem = { header: this.translate.instant('Name'), field: 'docname', type: 'String' };
        wColList.push(wItem);
        wItem = { header: this.translate.instant('Date'), field: 'date', type: 'Date' };
        wColList.push(wItem);        
        return wColList;
    }
}
